import Marquee from "react-fast-marquee";

const ITEMS = [
  "Managed IT",
  "Custom Software",
  "Cloud Architecture",
  "Cybersecurity",
  "24/7 Support",
  "DevOps",
];

export default function Ticker() {
  return (
    <section
      data-testid="ticker-section"
      className="border-y border-white/10 bg-[#0A0A0B] py-6 md:py-8"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="mx-8 md:mx-12 font-heading font-black uppercase tracking-tight text-3xl md:text-5xl text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.35)]">
              {item}
            </span>
            <span className="text-accent text-2xl md:text-4xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
